export default __webpack_public_path__ + "static/media/pic2.c7376cc5.jpg";